<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2 class="font-bold">舟向进气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="1#空气制备站" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/xihoumenSensor/station/main1"></router-link>
          </el-tooltip>
          <div class="stati sta-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_sensor("当量相对湿度", humidityTooltipErrorDehumidifierEquivalentLeft, humidityAllowedMaxDehumidifierEquivalentLeft)
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "相对湿度",
                    humidityTooltipErrorDehumidifierLeft,
                    humidityAllowedMaxDehumidifierLeft,
                    runningDehumidifierLeft,
                    malfunctionDehumidifierLeft
                  )
                }}
              </div>
              <div :class="errorDehumidifierLeft" class="state-info bottom-pos" @dblclick="hrefToStation('/station/main1')">
                <p>1#空气制备站送风</p>
                <p>
                  <span
                    >当量: {{ humidityDehumidifierEquivalentLeft | toFixed }}% <br />
                    {{ humidityDehumidifierLeft | toFixed }}% {{ temperatureDehumidifierLeft | toFixed }}°C</span
                  >
                  <span :class="runningClassLeft" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-right" content="2#空气制备站" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/xihoumenSensor/station/main2"></router-link>
          </el-tooltip>
          <div class="stati sta-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_sensor(
                    "当量相对湿度",
                    humidityTooltipErrorDehumidifierEquivalentRight,
                    humidityAllowedMaxDehumidifierEquivalentRight
                  )
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "相对湿度",
                    humidityTooltipErrorDehumidifierRight,
                    humidityAllowedMaxDehumidifierRight,
                    runningDehumidifierRight,
                    malfunctionDehumidifierRight
                  )
                }}
              </div>
              <div :class="errorDehumidifierRight" class="state-info bottom-pos" @dblclick="hrefToStation('/station/main2')">
                <p>2#空气制备站送风</p>
                <p>
                  <span
                    >当量: {{ humidityDehumidifierEquivalentRight | toFixed }}% <br />
                    {{ humidityDehumidifierRight | toFixed }}% {{ temperatureDehumidifierRight | toFixed }}°C</span
                  >
                  <span :class="runningClassRight" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZ1, humidityAllowedMaxJZ1) }}
              </div>
              <div :class="errorJZ1" class="state-info right-pos" @dblclick="hrefToScenario('da99bef6-45e4-4b03-b9e8-11ec59557508')">
                <p>JZ1传感器</p>
                <p>
                  <span
                    >{{ humidityJZ1 | toFixed }}% {{ temperatureJZ1 | toFixed }}°C <br />
                    {{ pressureJZ1 | toFixed }}Pa {{ volumeJZ1 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-left-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZ3, humidityAllowedMaxJZ3) }}
              </div>
              <div :class="errorJZ3" class="state-info right-pos" @dblclick="hrefToScenario('1bc81197-2b67-4770-abcb-7f852aac6cb3')">
                <p>JZ3传感器</p>
                <p>
                  <span
                    >{{ humidityJZ3 | toFixed }}% {{ temperatureJZ3 | toFixed }}°C <br />
                    {{ pressureJZ3 | toFixed }}Pa {{ volumeJZ3 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZM5, humidityAllowedMaxJZM5) }}
              </div>
              <div :class="errorJZM5" class="state-info left-pos" @dblclick="hrefToScenario('33510e2e-e625-4203-9d1a-886477a419c6')">
                <p>JZM5传感器</p>
                <p>
                  <span
                    >{{ humidityJZM5 | toFixed }}% {{ temperatureJZM5 | toFixed }}°C <br />
                    {{ pressureJZM5 | toFixed }}Pa {{ volumeJZM5 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZM3, humidityAllowedMaxJZM3) }}
              </div>
              <div :class="errorJZM3" class="state-info left-pos" @dblclick="hrefToScenario('a3d5cd6b-ae83-4ba2-8087-f4f49addaef6')">
                <p>JZM3传感器</p>
                <p>
                  <span
                    >{{ humidityJZM3 | toFixed }}% {{ temperatureJZM3 | toFixed }}°C <br />
                    {{ pressureJZM3 | toFixed }}Pa {{ volumeJZM3 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZM1, humidityAllowedMaxJZM1) }}
              </div>
              <div :class="errorJZM1" class="state-info right-pos" @dblclick="hrefToScenario('6856fb95-4e78-4358-89f0-ebaf6e04db63')">
                <p>JZM1传感器</p>
                <p>
                  <span
                    >{{ humidityJZM1 | toFixed }}% {{ temperatureJZM1 | toFixed }}°C <br />
                    {{ pressureJZM1 | toFixed }}Pa {{ volumeJZM1 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZM1Plus, humidityAllowedMaxJZM1Plus) }}
              </div>
              <div :class="errorJZM1Plus" class="state-info left-pos" @dblclick="hrefToScenario('852dc837-38fe-44db-968e-b23f9557f730')">
                <p>JZM1+传感器</p>
                <p>
                  <span
                    >{{ humidityJZM1Plus | toFixed }}% {{ temperatureJZM1Plus | toFixed }}°C <br />
                    {{ pressureJZM1Plus | toFixed }}Pa {{ volumeJZM1Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZM3Plus, humidityAllowedMaxJZM3Plus) }}
              </div>
              <div :class="errorJZM3Plus" class="state-info right-pos" @dblclick="hrefToScenario('7d266bf6-1f41-4e0c-885e-05247c5b599f')">
                <p>JZM3+传感器</p>
                <p>
                  <span
                    >{{ humidityJZM3Plus | toFixed }}% {{ temperatureJZM3Plus | toFixed }}°C <br />
                    {{ pressureJZM3Plus | toFixed }}Pa {{ volumeJZM3Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZM5Plus, humidityAllowedMaxJZM5Plus) }}
              </div>
              <div :class="errorJZM5Plus" class="state-info right-pos" @dblclick="hrefToScenario('696efb55-845f-4264-bf67-8067cdbe5847')">
                <p>JZM5+传感器</p>
                <p>
                  <span
                    >{{ humidityJZM5Plus | toFixed }}% {{ temperatureJZM5Plus | toFixed }}°C <br />
                    {{ pressureJZM5Plus | toFixed }}Pa {{ volumeJZM5Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-right-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZ3Plus, humidityAllowedMaxJZ3Plus) }}
              </div>
              <div :class="errorJZ3Plus" class="state-info left-pos" @dblclick="hrefToScenario('e61e8d37-e2e0-4851-990a-f566c6c04f5f')">
                <p>JZ3+传感器</p>
                <p>
                  <span
                    >{{ humidityJZ3Plus | toFixed }}% {{ temperatureJZ3Plus | toFixed }}°C <br />
                    {{ pressureJZ3Plus | toFixed }}Pa {{ volumeJZ3Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJZ1Plus, humidityAllowedMaxJZ1Plus) }}
              </div>
              <div :class="errorJZ1Plus" class="state-info left-pos" @dblclick="hrefToScenario('ac64a7e9-2415-4194-b833-d879039ea156')">
                <p>JZ1+传感器</p>
                <p>
                  <span
                    >{{ humidityJZ1Plus | toFixed }}% {{ temperatureJZ1Plus | toFixed }}°C <br />
                    {{ pressureJZ1Plus | toFixed }}Pa {{ volumeJZ1Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>舟向排气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZ0, humidityAllowedMaxPZ0) }}
              </div>
              <div :class="errorPZ0" class="state-info right-pos" @dblclick="hrefToScenario('74c9dfe5-bca2-4551-87ba-8a022e56b774')">
                <p>PZ0传感器</p>
                <p>
                  <span
                    >{{ humidityPZ0 | toFixed }}% {{ temperaturePZ0 | toFixed }}°C <br />
                    {{ pressurePZ0 | toFixed }}Pa {{ volumePZ0 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZ2, humidityAllowedMaxPZ2) }}
              </div>
              <div :class="errorPZ2" class="state-info right-pos" @dblclick="hrefToScenario('ec75918a-4e23-46b2-a792-bbcf6baa3d44')">
                <p>PZ2传感器</p>
                <p>
                  <span
                    >{{ humidityPZ2 | toFixed }}% {{ temperaturePZ2 | toFixed }}°C <br />
                    {{ pressurePZ2 | toFixed }}Pa {{ volumePZ2 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZ4, humidityAllowedMaxPZ4) }}
              </div>
              <div :class="errorPZ4" class="state-info right-pos" @dblclick="hrefToScenario('c1e70b65-f462-4c0b-8df7-b70b9350fa90')">
                <p>PZ4传感器</p>
                <p>
                  <span
                    >{{ humidityPZ4 | toFixed }}% {{ temperaturePZ4 | toFixed }}°C <br />
                    {{ pressurePZ4 | toFixed }}Pa {{ volumePZ4 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZM6, humidityAllowedMaxPZM6) }}
              </div>
              <div :class="errorPZM6" class="state-info left-pos" @dblclick="hrefToScenario('367a2660-b4f3-4ef6-9101-2eeb2702caa4')">
                <p>PZM6传感器</p>
                <p>
                  <span
                    >{{ humidityPZM6 | toFixed }}% {{ temperaturePZM6 | toFixed }}°C <br />
                    {{ pressurePZM6 | toFixed }}Pa {{ volumePZM6 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZM4, humidityAllowedMaxPZM4) }}
              </div>
              <div :class="errorPZM4" class="state-info left-pos" @dblclick="hrefToScenario('adf1fdf3-f29e-44bb-b68c-afc9d785d36c')">
                <p>PZM4传感器</p>
                <p>
                  <span
                    >{{ humidityPZM4 | toFixed }}% {{ temperaturePZM4 | toFixed }}°C <br />
                    {{ pressurePZM4 | toFixed }}Pa {{ volumePZM4 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZM2, humidityAllowedMaxPZM2) }}
              </div>
              <div :class="errorPZM2" class="state-info right-pos" @dblclick="hrefToScenario('a939be23-ec66-4fc8-a864-ef78856be9f0')">
                <p>PZM2传感器</p>
                <p>
                  <span
                    >{{ humidityPZM2 | toFixed }}% {{ temperaturePZM2 | toFixed }}°C <br />
                    {{ pressurePZM2 | toFixed }}Pa {{ volumePZM2 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZM0, humidityAllowedMaxPZM0) }}
              </div>
              <div :class="errorPZM0" class="state-info top-pos" @dblclick="hrefToScenario('8151da33-adc5-4610-a795-a3c42c8970cb')">
                <p>PZM0传感器</p>
                <p>
                  <span
                    >{{ humidityPZM0 | toFixed }}% {{ temperaturePZM0 | toFixed }}°C <br />
                    {{ pressurePZM0 | toFixed }}Pa {{ volumePZM0 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZM2Plus, humidityAllowedMaxPZM2Plus) }}
              </div>
              <div :class="errorPZM2Plus" class="state-info left-pos" @dblclick="hrefToScenario('69aab948-a4e3-487d-bad1-cd504fa65323')">
                <p>PZM2+传感器</p>
                <p>
                  <span
                    >{{ humidityPZM2Plus | toFixed }}% {{ temperaturePZM2Plus | toFixed }}°C <br />
                    {{ pressurePZM2Plus | toFixed }}Pa {{ volumePZM2Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZM4Plus, humidityAllowedMaxPZM4Plus) }}
              </div>
              <div :class="errorPZM4Plus" class="state-info right-pos" @dblclick="hrefToScenario('19cd3744-09f3-4da1-a53e-b482635e8ba8')">
                <p>PZM4+传感器</p>
                <p>
                  <span
                    >{{ humidityPZM4Plus | toFixed }}% {{ temperaturePZM4Plus | toFixed }}°C <br />
                    {{ pressurePZM4Plus | toFixed }}Pa {{ volumePZM4Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZM6Plus, humidityAllowedMaxPZM6Plus) }}
              </div>
              <div :class="errorPZM6Plus" class="state-info right-pos" @dblclick="hrefToScenario('be4fa249-97e5-4027-9da7-638f5614b76c')">
                <p>PZM6+传感器</p>
                <p>
                  <span
                    >{{ humidityPZM6Plus | toFixed }}% {{ temperaturePZM6Plus | toFixed }}°C <br />
                    {{ pressurePZM6Plus | toFixed }}Pa {{ volumePZM6Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZ4Plus, humidityAllowedMaxPZ4Plus) }}
              </div>
              <div :class="errorPZ4Plus" class="state-info left-pos" @dblclick="hrefToScenario('f2427696-6db0-4062-8e82-f0d38c9cd7de')">
                <p>PZ4+传感器</p>
                <p>
                  <span
                    >{{ humidityPZ4Plus | toFixed }}% {{ temperaturePZ4Plus | toFixed }}°C <br />
                    {{ pressurePZ4Plus | toFixed }}Pa {{ volumePZ4Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZ2Plus, humidityAllowedMaxPZ2Plus) }}
              </div>
              <div :class="errorPZ2Plus" class="state-info left-pos" @dblclick="hrefToScenario('2f2291a4-7e9f-4102-9dfc-a08662c4113c')">
                <p>PZ2+传感器</p>
                <p>
                  <span
                    >{{ humidityPZ2Plus | toFixed }}% {{ temperaturePZ2Plus | toFixed }}°C <br />
                    {{ pressurePZ2Plus | toFixed }}Pa {{ volumePZ2Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPZ0Plus, humidityAllowedMaxPZ0Plus) }}
              </div>
              <div :class="errorPZ0Plus" class="state-info left-pos" @dblclick="hrefToScenario('06dfa0f6-9ab8-4f44-ae01-050a1c8fed48')">
                <p>PZ0+传感器</p>
                <p>
                  <span
                    >{{ humidityPZ0Plus | toFixed }}% {{ temperaturePZ0Plus | toFixed }}°C <br />
                    {{ pressurePZ0Plus | toFixed }}Pa {{ volumePZ0Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "xihoumenSensor",
      bridgeId: "3aeeb5b1-f586-43c4-b03c-2e5880d2e541",

      //humidity, temperature
      humidityPZ0: "--",
      humidityPN0: "--",
      humidityJZ1: "--",
      humidityJN1: "--",
      humidityPZ2: "--",
      humidityPN2: "--",
      humidityJZ3: "--",
      humidityJN3: "--",
      humidityPZ4: "--",
      humidityPN4: "--",
      humidityPZM6: "--",
      humidityPNM6: "--",
      humidityJZM5: "--",
      humidityJNM5: "--",
      humidityPZM4: "--",
      humidityPNM4: "--",
      humidityJZM3: "--",
      humidityJNM3: "--",
      humidityPZM2: "--",
      humidityPNM2: "--",
      humidityJZM1: "--",
      humidityJNM1: "--",
      humidityPZM0: "--",
      humidityPNM0: "--",
      humidityPZ0Plus: "--",
      humidityPN0Plus: "--",
      humidityJZ1Plus: "--",
      humidityJN1Plus: "--",
      humidityPZ2Plus: "--",
      humidityPN2Plus: "--",
      humidityJZ3Plus: "--",
      humidityJN3Plus: "--",
      humidityPZ4Plus: "--",
      humidityPN4Plus: "--",
      humidityPZM6Plus: "--",
      humidityPNM6Plus: "--",
      humidityJZM5Plus: "--",
      humidityJNM5Plus: "--",
      humidityPZM4Plus: "--",
      humidityPNM4Plus: "--",
      humidityJZM3Plus: "--",
      humidityJNM3Plus: "--",
      humidityPZM2Plus: "--",
      humidityPNM2Plus: "--",
      humidityJZM1Plus: "--",
      humidityJNM1Plus: "--",
      humidityDehumidifierLeft: "--",
      humidityDehumidifierRight: "--",
      humidityDehumidifierEquivalentLeft: "--",
      humidityDehumidifierEquivalentRight: "--",

      temperaturePZ0: "--",
      temperaturePN0: "--",
      temperatureJZ1: "--",
      temperatureJN1: "--",
      temperaturePZ2: "--",
      temperaturePN2: "--",
      temperatureJZ3: "--",
      temperatureJN3: "--",
      temperaturePZ4: "--",
      temperaturePN4: "--",
      temperaturePZM6: "--",
      temperaturePNM6: "--",
      temperatureJZM5: "--",
      temperatureJNM5: "--",
      temperaturePZM4: "--",
      temperaturePNM4: "--",
      temperatureJZM3: "--",
      temperatureJNM3: "--",
      temperaturePZM2: "--",
      temperaturePNM2: "--",
      temperatureJZM1: "--",
      temperatureJNM1: "--",
      temperaturePZM0: "--",
      temperaturePNM0: "--",
      temperaturePZ0Plus: "--",
      temperaturePN0Plus: "--",
      temperatureJZ1Plus: "--",
      temperatureJN1Plus: "--",
      temperaturePZ2Plus: "--",
      temperaturePN2Plus: "--",
      temperatureJZ3Plus: "--",
      temperatureJN3Plus: "--",
      temperaturePZ4Plus: "--",
      temperaturePN4Plus: "--",
      temperaturePZM6Plus: "--",
      temperaturePNM6Plus: "--",
      temperatureJZM5Plus: "--",
      temperatureJNM5Plus: "--",
      temperaturePZM4Plus: "--",
      temperaturePNM4Plus: "--",
      temperatureJZM3Plus: "--",
      temperatureJNM3Plus: "--",
      temperaturePZM2Plus: "--",
      temperaturePNM2Plus: "--",
      temperatureJZM1Plus: "--",
      temperatureJNM1Plus: "--",
      temperatureDehumidifierLeft: "--",
      temperatureDehumidifierRight: "--",

      pressurePZ0: "--",
      pressurePN0: "--",
      pressureJZ1: "--",
      pressureJN1: "--",
      pressurePZ2: "--",
      pressurePN2: "--",
      pressureJZ3: "--",
      pressureJN3: "--",
      pressurePZ4: "--",
      pressurePN4: "--",
      pressurePZM6: "--",
      pressurePNM6: "--",
      pressureJZM5: "--",
      pressureJNM5: "--",
      pressurePZM4: "--",
      pressurePNM4: "--",
      pressureJZM3: "--",
      pressureJNM3: "--",
      pressurePZM2: "--",
      pressurePNM2: "--",
      pressureJZM1: "--",
      pressureJNM1: "--",
      pressurePZM0: "--",
      pressurePNM0: "--",
      pressurePZ0Plus: "--",
      pressurePN0Plus: "--",
      pressureJZ1Plus: "--",
      pressureJN1Plus: "--",
      pressurePZ2Plus: "--",
      pressurePN2Plus: "--",
      pressureJZ3Plus: "--",
      pressureJN3Plus: "--",
      pressurePZ4Plus: "--",
      pressurePN4Plus: "--",
      pressurePZM6Plus: "--",
      pressurePNM6Plus: "--",
      pressureJZM5Plus: "--",
      pressureJNM5Plus: "--",
      pressurePZM4Plus: "--",
      pressurePNM4Plus: "--",
      pressureJZM3Plus: "--",
      pressureJNM3Plus: "--",
      pressurePZM2Plus: "--",
      pressurePNM2Plus: "--",
      pressureJZM1Plus: "--",
      pressureJNM1Plus: "--",

      flowPZ0: "--",
      flowPN0: "--",
      flowJZ1: "--",
      flowJN1: "--",
      flowPZ2: "--",
      flowPN2: "--",
      flowJZ3: "--",
      flowJN3: "--",
      flowPZ4: "--",
      flowPN4: "--",
      flowPZM6: "--",
      flowPNM6: "--",
      flowJZM5: "--",
      flowJNM5: "--",
      flowPZM4: "--",
      flowPNM4: "--",
      flowJZM3: "--",
      flowJNM3: "--",
      flowPZM2: "--",
      flowPNM2: "--",
      flowJZM1: "--",
      flowJNM1: "--",
      flowPZM0: "--",
      flowPNM0: "--",
      flowPZ0Plus: "--",
      flowPN0Plus: "--",
      flowJZ1Plus: "--",
      flowJN1Plus: "--",
      flowPZ2Plus: "--",
      flowPN2Plus: "--",
      flowJZ3Plus: "--",
      flowJN3Plus: "--",
      flowPZ4Plus: "--",
      flowPN4Plus: "--",
      flowPZM6Plus: "--",
      flowPNM6Plus: "--",
      flowJZM5Plus: "--",
      flowJNM5Plus: "--",
      flowPZM4Plus: "--",
      flowPNM4Plus: "--",
      flowJZM3Plus: "--",
      flowJNM3Plus: "--",
      flowPZM2Plus: "--",
      flowPNM2Plus: "--",
      flowJZM1Plus: "--",
      flowJNM1Plus: "--",

      //running
      runningDehumidifierLeft: "--",
      runningDehumidifierRight: "--",

      //malfunction
      malfunctionDehumidifierLeft: "--",
      malfunctionDehumidifierRight: "--",

      //error
      errorPZ0: "--",
      errorPN0: "--",
      errorJZ1: "--",
      errorJN1: "--",
      errorPZ2: "--",
      errorPN2: "--",
      errorJZ3: "--",
      errorJN3: "--",
      errorPZ4: "--",
      errorPN4: "--",
      errorPZM6: "--",
      errorPNM6: "--",
      errorJZM5: "--",
      errorJNM5: "--",
      errorPZM4: "--",
      errorPNM4: "--",
      errorJZM3: "--",
      errorJNM3: "--",
      errorPZM2: "--",
      errorPNM2: "--",
      errorJZM1: "--",
      errorJNM1: "--",
      errorPZM0: "--",
      errorPNM0: "--",
      errorPZ0Plus: "--",
      errorPN0Plus: "--",
      errorJZ1Plus: "--",
      errorJN1Plus: "--",
      errorPZ2Plus: "--",
      errorPN2Plus: "--",
      errorJZ3Plus: "--",
      errorJN3Plus: "--",
      errorPZ4Plus: "--",
      errorPN4Plus: "--",
      errorPZM6Plus: "--",
      errorPNM6Plus: "--",
      errorJZM5Plus: "--",
      errorJNM5Plus: "--",
      errorPZM4Plus: "--",
      errorPNM4Plus: "--",
      errorJZM3Plus: "--",
      errorJNM3Plus: "--",
      errorPZM2Plus: "--",
      errorPNM2Plus: "--",
      errorJZM1Plus: "--",
      errorJNM1Plus: "--",
      errorDehumidifierLeft: "--",
      errorDehumidifierRight: "--",

      //running class
      runningClassLeft: "--",
      runningClassRight: "--",

      //humidity allowed max
      humidityAllowedMaxPZ0: "--",
      humidityAllowedMaxPN0: "--",
      humidityAllowedMaxJZ1: "--",
      humidityAllowedMaxJN1: "--",
      humidityAllowedMaxPZ2: "--",
      humidityAllowedMaxPN2: "--",
      humidityAllowedMaxJZ3: "--",
      humidityAllowedMaxJN3: "--",
      humidityAllowedMaxPZ4: "--",
      humidityAllowedMaxPN4: "--",
      humidityAllowedMaxPZM6: "--",
      humidityAllowedMaxPNM6: "--",
      humidityAllowedMaxJZM5: "--",
      humidityAllowedMaxJNM5: "--",
      humidityAllowedMaxPZM4: "--",
      humidityAllowedMaxPNM4: "--",
      humidityAllowedMaxJZM3: "--",
      humidityAllowedMaxJNM3: "--",
      humidityAllowedMaxPZM2: "--",
      humidityAllowedMaxPNM2: "--",
      humidityAllowedMaxJZM1: "--",
      humidityAllowedMaxJNM1: "--",
      humidityAllowedMaxPZM0: "--",
      humidityAllowedMaxPNM0: "--",
      humidityAllowedMaxPZ0Plus: "--",
      humidityAllowedMaxPN0Plus: "--",
      humidityAllowedMaxJZ1Plus: "--",
      humidityAllowedMaxJN1Plus: "--",
      humidityAllowedMaxPZ2Plus: "--",
      humidityAllowedMaxPN2Plus: "--",
      humidityAllowedMaxJZ3Plus: "--",
      humidityAllowedMaxJN3Plus: "--",
      humidityAllowedMaxPZ4Plus: "--",
      humidityAllowedMaxPN4Plus: "--",
      humidityAllowedMaxPZM6Plus: "--",
      humidityAllowedMaxPNM6Plus: "--",
      humidityAllowedMaxJZM5Plus: "--",
      humidityAllowedMaxJNM5Plus: "--",
      humidityAllowedMaxPZM4Plus: "--",
      humidityAllowedMaxPNM4Plus: "--",
      humidityAllowedMaxJZM3Plus: "--",
      humidityAllowedMaxJNM3Plus: "--",
      humidityAllowedMaxPZM2Plus: "--",
      humidityAllowedMaxPNM2Plus: "--",
      humidityAllowedMaxJZM1Plus: "--",
      humidityAllowedMaxJNM1Plus: "--",
      humidityAllowedMaxDehumidifierLeft: "--",
      humidityAllowedMaxDehumidifierRight: "--",
      humidityAllowedMaxDehumidifierEquivalentLeft: "--",
      humidityAllowedMaxDehumidifierEquivalentRight: "--",

      //humidity tooltip error
      humidityTooltipErrorPZ0: "--",
      humidityTooltipErrorPN0: "--",
      humidityTooltipErrorJZ1: "--",
      humidityTooltipErrorJN1: "--",
      humidityTooltipErrorPZ2: "--",
      humidityTooltipErrorPN2: "--",
      humidityTooltipErrorJZ3: "--",
      humidityTooltipErrorJN3: "--",
      humidityTooltipErrorPZ4: "--",
      humidityTooltipErrorPN4: "--",
      humidityTooltipErrorPZM6: "--",
      humidityTooltipErrorPNM6: "--",
      humidityTooltipErrorJZM5: "--",
      humidityTooltipErrorJNM5: "--",
      humidityTooltipErrorPZM4: "--",
      humidityTooltipErrorPNM4: "--",
      humidityTooltipErrorJZM3: "--",
      humidityTooltipErrorJNM3: "--",
      humidityTooltipErrorPZM2: "--",
      humidityTooltipErrorPNM2: "--",
      humidityTooltipErrorJZM1: "--",
      humidityTooltipErrorJNM1: "--",
      humidityTooltipErrorPZM0: "--",
      humidityTooltipErrorPNM0: "--",
      humidityTooltipErrorPZ0Plus: "--",
      humidityTooltipErrorPN0Plus: "--",
      humidityTooltipErrorJZ1Plus: "--",
      humidityTooltipErrorJN1Plus: "--",
      humidityTooltipErrorPZ2Plus: "--",
      humidityTooltipErrorPN2Plus: "--",
      humidityTooltipErrorJZ3Plus: "--",
      humidityTooltipErrorJN3Plus: "--",
      humidityTooltipErrorPZ4Plus: "--",
      humidityTooltipErrorPN4Plus: "--",
      humidityTooltipErrorPZM6Plus: "--",
      humidityTooltipErrorPNM6Plus: "--",
      humidityTooltipErrorJZM5Plus: "--",
      humidityTooltipErrorJNM5Plus: "--",
      humidityTooltipErrorPZM4Plus: "--",
      humidityTooltipErrorPNM4Plus: "--",
      humidityTooltipErrorJZM3Plus: "--",
      humidityTooltipErrorJNM3Plus: "--",
      humidityTooltipErrorPZM2Plus: "--",
      humidityTooltipErrorPNM2Plus: "--",
      humidityTooltipErrorJZM1Plus: "--",
      humidityTooltipErrorJNM1Plus: "--",
      humidityTooltipErrorDehumidifierLeft: "--",
      humidityTooltipErrorDehumidifierRight: "--",
      humidityTooltipErrorDehumidifierEquivalentLeft: "--",
      humidityTooltipErrorDehumidifierEquivalentRight: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityPZ0: "b7a7bc41-7c44-4eee-844f-f6c496c9aa4c",
        humidityPN0: "dcd022fa-dbb7-4602-b25a-1d980d051b1d",
        humidityJZ1: "89c5760e-68da-4514-934e-06fc76c4c3be",
        humidityJN1: "a523e8bd-f25f-4191-a34c-9b082ff81add",
        humidityPZ2: "2be89920-f580-490f-af72-dbb6ab4988e9",
        humidityPN2: "12dfebcc-aa51-48a8-a1ee-eb48f847bd86",
        humidityJZ3: "78851098-4295-4907-83d4-b3c600867c44",
        humidityJN3: "7ab5a8c4-9727-4448-a78f-d2188da78dd8",
        humidityPZ4: "439fc8f5-237f-4034-97d8-a6d725289741",
        humidityPN4: "38b2a8dc-74a1-42a8-bacb-c04cdf16e423",
        humidityPZM6: "28f7fdb4-1664-47e8-bfd6-a0d3f6c01a62",
        humidityPNM6: "32b36598-2a0b-42d5-b512-976d4113dce1",
        humidityJZM5: "13bf98b6-a30c-466c-a041-572c35c378ec",
        humidityJNM5: "3d71805a-0eee-4aea-866e-fe2e06a2a11d",
        humidityPZM4: "6250987d-5a8d-4a00-88a3-5179f03d7863",
        humidityPNM4: "e1e6cd8b-dcf4-416a-9a7e-67464fb29070",
        humidityJZM3: "31a24627-298a-461c-a5ec-f1d2cf5b9310",
        humidityJNM3: "e0ce6270-4654-4b6c-91ee-b34d190fc9bd",
        humidityPZM2: "9c95de82-34d9-47f4-94dd-7ec0ed05c90a",
        humidityPNM2: "da07cff9-9154-4902-b9e0-4b1b3da8bfd0",
        humidityJZM1: "22d94e3f-1e20-4a95-8812-b13785a9f3e3",
        humidityJNM1: "1df49bd7-1b47-44e1-accb-ab1e99958742",
        humidityPZM0: "eb0fcf4c-21d7-451b-8a84-5d09de9d56f3",
        humidityPNM0: "4965117a-a463-48db-a704-954fea7560a2",
        humidityPZ0Plus: "5098cd4b-1da7-4147-9ffd-e82ff40ed0fd",
        humidityPN0Plus: "b4c469be-0dcb-441f-bdad-5fa2c006bb5c",
        humidityJZ1Plus: "6e58181c-ea4c-4b3a-bedc-484734e5e919",
        humidityJN1Plus: "c103d74e-0131-4ad3-851c-695445769b89",
        humidityPZ2Plus: "7338831c-e07b-4597-82fd-05ca2e4f6e2c",
        humidityPN2Plus: "79b6a168-bc5c-459f-9e8c-0f6f5f561a80",
        humidityJZ3Plus: "582a14db-b6b3-4496-821d-3341f609ca96",
        humidityJN3Plus: "a5de7a39-bf78-42ea-855e-578965545521",
        humidityPZ4Plus: "871617ba-84d6-4142-9fdd-e005761bd7a6",
        humidityPN4Plus: "addc0561-99b7-4224-8926-93833f92669c",
        humidityPZM6Plus: "de725c06-ede4-4bdf-b87f-8c19f4538155",
        humidityPNM6Plus: "dadb6cd4-dc67-405d-8ef3-ffcd6f436b9a",
        humidityJZM5Plus: "b14e1cc4-d893-4399-804e-b08e2d786f24",
        humidityJNM5Plus: "678f0843-0002-4822-ae0a-20c4521aac0d",
        humidityPZM4Plus: "c82b5039-f14d-4335-907d-4725887de518",
        humidityPNM4Plus: "051c0b0d-ecd9-45a4-89d9-9ed58d84a7e5",
        humidityJZM3Plus: "d8814cd9-6260-401d-ae18-77a099913181",
        humidityJNM3Plus: "cc40c1d9-ec87-4072-a902-8affa2a1aeb7",
        humidityPZM2Plus: "fb7ef1a2-5fba-48a1-a49f-75910b847470",
        humidityPNM2Plus: "c8c39909-e06f-4aab-a4b5-b213c9571257",
        humidityJZM1Plus: "000e9869-6bc7-4c2e-a592-d4ece922abce",
        humidityJNM1Plus: "5c65d43e-e4f6-4292-890a-76c27b05ae77",
        humidityDehumidifierLeft: "42e9d3e0-e6bb-4e99-a70a-84807a10db8b",
        humidityDehumidifierRight: "7d31a969-65dd-4d8d-8466-6258bd6d97d5",
        humidityDehumidifierEquivalentLeft: "3306957b-f730-4104-aacf-1377d9958a65",
        humidityDehumidifierEquivalentRight: "ee5badbc-3e0c-4316-8074-2ebf3f619342",

        temperaturePZ0: "42098c97-519e-4da2-a636-9003ac627106",
        temperaturePN0: "f8ad66cd-456f-4545-a972-850931b1b22b",
        temperatureJZ1: "0d3d7fd2-117c-4f73-9d98-70ceb5eda393",
        temperatureJN1: "59d07332-9c2f-4b95-bdd4-a46795bbc79e",
        temperaturePZ2: "057a28ac-fcc5-4ac4-ab0a-ff335191bc45",
        temperaturePN2: "7c907395-9711-4a75-b7f6-5dfb5c5b45d0",
        temperatureJZ3: "fa65732a-f9fe-4e88-8740-9125161924fd",
        temperatureJN3: "0cca063b-a620-44fc-9bb7-879475d5bef3",
        temperaturePZ4: "13a67604-d332-41ad-a6a2-965a4a5141d5",
        temperaturePN4: "06f11803-2bfc-45f7-a3b5-7793d823d402",
        temperaturePZM6: "cd11f6ef-dcc0-4f5a-a91d-8a7fede3e8e9",
        temperaturePNM6: "846334f0-6050-4a74-8c46-f8813eb5be8f",
        temperatureJZM5: "74090537-74f5-4832-8371-ceb76609b492",
        temperatureJNM5: "89ef25b0-6504-4fbe-9146-7337362ab9ad",
        temperaturePZM4: "1825a1d2-cf8f-4fe0-9b8f-17111f73fd32",
        temperaturePNM4: "a561df5a-2b0f-4f31-9e25-5dfe5661c005",
        temperatureJZM3: "ae0d57e4-f580-42c4-bc28-a159defc4a9f",
        temperatureJNM3: "561073b5-eaac-438c-84aa-e07a2d6effa1",
        temperaturePZM2: "cdf03c0c-afce-42e3-b079-949cd323074f",
        temperaturePNM2: "3584550c-1413-46d7-9626-b0739944ea81",
        temperatureJZM1: "2855808a-8090-49f6-8fe1-ad4e3c8ba14e",
        temperatureJNM1: "80866f75-f973-4830-9727-3391230ad43f",
        temperaturePZM0: "935446be-babc-4200-b7f2-b7c3547deaf5",
        temperaturePNM0: "370b74d2-898b-4042-898a-fefc133679de",
        temperaturePZ0Plus: "62af7530-9c45-4e65-8c2b-3077ea61574d",
        temperaturePN0Plus: "f2960664-dc2f-4664-b261-94bd2ad85f81",
        temperatureJZ1Plus: "e42c907c-7931-4e5e-b866-79f680cb08c1",
        temperatureJN1Plus: "bfaee626-54ef-4b05-ada0-57c5cca06efb",
        temperaturePZ2Plus: "ec06f28a-5994-4a55-8b69-870ad38575d9",
        temperaturePN2Plus: "27228715-dde7-4e88-9b3d-6e0c9bf64e31",
        temperatureJZ3Plus: "cf0ee665-6492-482d-903f-9a7f7aab5aed",
        temperatureJN3Plus: "26cb5906-c5a7-4cfa-b058-9f78362afcfd",
        temperaturePZ4Plus: "2af6a52b-938b-46aa-a6b6-aeeeedc8ee6d",
        temperaturePN4Plus: "28139917-0734-486d-8a27-0c96b6ab8905",
        temperaturePZM6Plus: "07afc144-4986-4a9a-b50b-fbf094545fb0",
        temperaturePNM6Plus: "3f2d683a-f9ab-400e-8b42-f96b10548c17",
        temperatureJZM5Plus: "aec3778b-5bec-48a9-bc63-c35444cb4e0a",
        temperatureJNM5Plus: "2d59deb3-1a03-4fa3-85fe-ec4f5d081feb",
        temperaturePZM4Plus: "5ee42386-8c07-46a1-9280-0f0ef3f07be0",
        temperaturePNM4Plus: "86b90e8b-6835-4553-8647-6a00188e27b6",
        temperatureJZM3Plus: "3a5e0627-4a58-4aec-a131-2c1d76f46d3d",
        temperatureJNM3Plus: "3e313b8d-3b93-4ee2-932f-d85937704410",
        temperaturePZM2Plus: "0e09667a-ac54-4f27-8b06-5c2960c624ee",
        temperaturePNM2Plus: "ac94b52c-73d4-4e35-9d25-7ca1a1964b56",
        temperatureJZM1Plus: "b815a1bf-bee2-4ee3-be27-6a9afde90bee",
        temperatureJNM1Plus: "123090a0-3f09-4f25-b0dd-b30131133a7f",
        temperatureDehumidifierLeft: "d08e8b75-6040-4405-9273-c66741a556ef",
        temperatureDehumidifierRight: "582b8de3-feb6-46e8-b38b-5f1cf7382b99",

        pressurePZ0: "f244f738-3caa-42e7-bb6f-349fd51c09e7",
        pressurePN0: "caeb771e-1aeb-4ca6-bccc-4b28ee8f5991",
        pressureJZ1: "bb74d05d-a57b-484b-95eb-3c7a6ed20eed",
        pressureJN1: "f7e34010-ef08-437b-bada-3e546c577a5e",
        pressurePZ2: "a1e0d818-671a-4bd5-828e-cb5635c5942a",
        pressurePN2: "861bd36c-51f0-4c43-93c7-b91fa99e0e16",
        pressureJZ3: "8a257ae0-e0f3-4864-a764-ee9602b9ffae",
        pressureJN3: "10c73356-6c0d-4edc-9890-e7d749a053d8",
        pressurePZ4: "13a530ec-2d18-44ba-b828-18560dab6904",
        pressurePN4: "6818e06d-ead3-4b5e-bd96-63dd400781a7",
        pressurePZM6: "31b9dac7-21a5-449f-b170-d170254a0a5c",
        pressurePNM6: "589a03ab-8533-481c-b2ed-a1dd87d638bc",
        pressureJZM5: "66d18883-4e3f-401d-910f-95c2152ddbcf",
        pressureJNM5: "8670b9f2-d9fe-42c2-bf23-75c6de99ff40",
        pressurePZM4: "fa4a6341-1241-4142-9242-d958a68838ae",
        pressurePNM4: "9f29e0d9-fceb-49e7-8e6b-162e6dac02a4",
        pressureJZM3: "f2479846-21ff-4837-a509-7610714e27f7",
        pressureJNM3: "f62d6b24-8bb9-467f-bc86-2f0649b86239",
        pressurePZM2: "ea7401cb-0c4f-4fb4-a57a-b4bf3c2ef5ae",
        pressurePNM2: "e214ab54-97aa-44c1-b264-d51f782b8ea7",
        pressureJZM1: "741035f5-c03b-4fe3-aab3-50a6b949b0e8",
        pressureJNM1: "3d167a63-5601-402a-b362-843bc5a5dcaf",
        pressurePZM0: "93c1e9fe-6b1a-4a6b-a269-0bd812f5c583",
        pressurePNM0: "c7df8e34-a56f-4cf2-80f0-2da3e0f6b02a",
        pressurePZ0Plus: "a0392846-308b-4405-92b9-f86a8eb52f22",
        pressurePN0Plus: "364452ed-5000-4037-9563-d820383dd264",
        pressureJZ1Plus: "a10641f3-8300-4929-b4dc-3cc2f8839239",
        pressureJN1Plus: "3f194050-45e6-4aac-8c0e-7a1f4e3589f2",
        pressurePZ2Plus: "55346e02-e177-4dc9-9790-30136dbf2960",
        pressurePN2Plus: "e7d5197f-ff8b-4002-a0ba-eb7794f6e684",
        pressureJZ3Plus: "a76cbda2-7aa9-4de6-8f6a-9a8e2cad3434",
        pressureJN3Plus: "f03c7628-791b-4523-8966-50bccc921f79",
        pressurePZ4Plus: "01097cf9-bcf3-4ce3-baa1-88e471c4c257",
        pressurePN4Plus: "ebdf7778-965c-447c-b5a8-186c2f36f59e",
        pressurePZM6Plus: "ec892e65-c2a6-4072-a0c4-ad1b93dea638",
        pressurePNM6Plus: "9058402e-3356-4b8c-bc2f-28cfafa8bc3c",
        pressureJZM5Plus: "cab2c66a-a23d-4ae1-9c5a-64286db51f6d",
        pressureJNM5Plus: "ef285583-78e8-4e82-9f57-48bcfca0d169",
        pressurePZM4Plus: "24fe92f5-3e8f-4c66-aabd-2194bb8b9053",
        pressurePNM4Plus: "e9f403bc-3d84-4101-ae4f-b5486b3616fd",
        pressureJZM3Plus: "2d67f69f-4b38-4cef-999c-da8425df4c76",
        pressureJNM3Plus: "52c4c5bf-92cd-4d1d-91d4-5418deecac72",
        pressurePZM2Plus: "e0a39556-267d-4b27-8b7b-dd16fd197b40",
        pressurePNM2Plus: "c600e614-f59e-4aff-9ba0-3072a76f69ea",
        pressureJZM1Plus: "00ac8e0b-ea19-4a75-bf9e-f40c655fcc31",
        pressureJNM1Plus: "76fd3877-a737-4212-b56d-13bacabb0355",

        volumePZ0: "406171cb-3e0d-4155-9e68-115d8c59c860",
        volumePN0: "97093ee1-db0e-4ca6-896c-e79e2c065300",
        volumeJZ1: "ca04c069-feb7-4d99-8c8f-6a2de3bb1b4f",
        volumeJN1: "1d68839f-e8ec-416f-9d98-6b648c7ca369",
        volumePZ2: "19afe4d2-68c2-4873-b13a-ad9628f1a051",
        volumePN2: "3576d519-0007-46fc-968f-e40b8cbaf7e0",
        volumeJZ3: "3479b400-6e59-44c4-9995-987506546304",
        volumeJN3: "fde355cc-2345-44de-aac8-e189415b865c",
        volumePZ4: "0363384d-776b-4440-95cb-ab30edf5116a",
        volumePN4: "88225fae-c164-45ba-97f3-188e3d18761e",
        volumePZM6: "040fb176-34d1-4d0f-a480-c8ba42ce0a14",
        volumePNM6: "0e7c08d2-298d-40dc-bcc1-162fa9e164e7",
        volumeJZM5: "6570cce2-3d35-48f5-bcbd-add95e27aad2",
        volumeJNM5: "b1405da4-94a0-4365-8d60-59aa26b67488",
        volumePZM4: "b6483de0-76b3-47ba-801f-b140c4e2b7bd",
        volumePNM4: "fbcc6438-a7c4-4f48-96f5-6e025dfb22e0",
        volumeJZM3: "bc6b32cd-0b9b-47cd-8125-4603ae2fd8d2",
        volumeJNM3: "86aa7490-5b83-4c48-bd9c-ff4ce6512f47",
        volumePZM2: "99102fe4-7171-4336-8ca0-8dc60df7b780",
        volumePNM2: "c93b35a1-e2da-4001-b3b8-8d13b502b8b1",
        volumeJZM1: "2cabd6cc-c06d-4d18-b77f-f5e03cc5fe41",
        volumeJNM1: "551affd6-3573-4e21-a125-32db05e027f6",
        volumePZM0: "e68aea46-37e3-4ec0-b55b-e31bb92347ea",
        volumePNM0: "bdc749d1-580e-4003-8636-5ee53e851e51",
        volumePZ0Plus: "f6565d45-aa38-49b3-91a3-cf296fb50499",
        volumePN0Plus: "33c03e31-8582-43a3-b4fc-bf2a2571f988",
        volumeJZ1Plus: "c3212d1a-eca7-44c8-9153-cfd2c30565fd",
        volumeJN1Plus: "56b280d5-a741-40d9-8716-b06c50555ddc",
        volumePZ2Plus: "5af29bd3-239e-457b-ae7e-a8d523162cd5",
        volumePN2Plus: "2a49912f-9203-4d83-b129-4cfd1c088c1b",
        volumeJZ3Plus: "ad7f2a7e-cdba-4ea6-9072-e3e748b55ea1",
        volumeJN3Plus: "0704441d-f30b-4912-bed8-8b93f2e3bcd3",
        volumePZ4Plus: "81ff210e-3fa2-486c-b0dd-0d8ed2ba610c",
        volumePN4Plus: "5a058bc2-92c0-49e8-b913-088654f1036b",
        volumePZM6Plus: "0fed66ad-86df-4650-9641-a48d3f43db70",
        volumePNM6Plus: "9c7972bc-58aa-4c47-ac3b-9c1925f52c39",
        volumeJZM5Plus: "5a3fb84e-07ac-4077-b94b-a75f45565700",
        volumeJNM5Plus: "df1d9c94-a01e-4e46-a713-d9edb39ed435",
        volumePZM4Plus: "c9c7cab5-ce65-441d-aada-f6e2f6b8727c",
        volumePNM4Plus: "66742cde-f69a-4699-9f88-b52b36e8091f",
        volumeJZM3Plus: "446188d1-f998-4424-b11f-f772314222c4",
        volumeJNM3Plus: "95f780fa-ed5b-4bf0-8503-42972e3269a2",
        volumePZM2Plus: "7ddca390-f42d-4676-9dc9-5d8d2f90dcc7",
        volumePNM2Plus: "0288dea1-cfa7-44ad-98aa-687df9e82597",
        volumeJZM1Plus: "4fc5e48d-080e-4e67-86e8-38f41ddf9736",
        volumeJNM1Plus: "0f61ea0f-fe9e-46d5-8ed9-a791b68a498e",

        flowPZ0: "df32313e-d6d6-4898-8d01-a50ae8a215f7",
        flowPN0: "56a3f961-15da-4739-a6ca-fcb05f84cb4c",
        flowJZ1: "9ae9dd34-a7d3-4eb3-b874-74ea31943215",
        flowJN1: "54646b8c-7f11-4284-9f0d-947f10e8528c",
        flowPZ2: "77082b75-7ad9-4531-8dfb-077420993a3c",
        flowPN2: "4fa2e93e-d817-4d5c-888b-f7a45401a2c3",
        flowJZ3: "d951413a-b9a0-45f5-a345-535e1bcacc2e",
        flowJN3: "65094f3b-958d-4777-b3fe-5f72a8f88ccb",
        flowPZ4: "d77c21b6-c342-4d95-9329-61afb67b8a54",
        flowPN4: "d5995fae-5f46-4516-ae59-dc7d5336f55c",
        flowPZM6: "66b0812c-041e-4b69-ae38-d3513451815f",
        flowPNM6: "16655bf0-af2e-4b5c-bcc1-2f2a72e53250",
        flowJZM5: "d1dfc052-19f0-4637-89cb-a55e97f43869",
        flowJNM5: "a9f31f51-7756-4715-a1ec-bd1f16bcda81",
        flowPZM4: "ea82747a-06c4-4802-aeab-f1b0f260fbfb",
        flowPNM4: "711f9828-ce8d-4285-92d9-7f3af141c74f",
        flowJZM3: "e5c54b69-f2ce-4688-81d6-f632697bd4c3",
        flowJNM3: "8cf7a0b3-181f-41ac-acaa-05f3f6b98c45",
        flowPZM2: "d79fdbb9-4744-4898-92c8-105e326cfd47",
        flowPNM2: "b2a54c81-b70a-4c22-9955-0ca6740605c4",
        flowJZM1: "48319c2e-81a1-4f1c-bc16-f7a9ddf1204b",
        flowJNM1: "2a8536bb-e854-420e-8012-6288372081c4",
        flowPZM0: "4442f076-2433-43f7-bf52-14d9e3b17f2c",
        flowPNM0: "fbf52214-2ab2-4776-a131-f06eb336aaef",
        flowPZ0Plus: "8b0bbf94-8579-4921-a3ea-7f152b914944",
        flowPN0Plus: "21f3c2c9-0bf2-456d-b23d-6a2ddaba6d47",
        flowJZ1Plus: "f6fae54a-0f60-41fa-b619-1f04e47b27e9",
        flowJN1Plus: "b233690c-d41b-4089-be0b-ac0066510c79",
        flowPZ2Plus: "5fa1a03c-8583-4591-8218-3e7d2b13b744",
        flowPN2Plus: "05d684fc-22aa-40f4-9538-206892a1090d",
        flowJZ3Plus: "be433746-c91f-46ea-ae75-93e2d92a36ef",
        flowJN3Plus: "3ef948f2-b9b8-4b2b-90cd-94ddba09e121",
        flowPZ4Plus: "fa104afb-9c42-4bcf-a8aa-8744f30e5145",
        flowPN4Plus: "8624b228-288d-428f-80e6-50e9d38070d1",
        flowPZM6Plus: "2a58ee7c-d347-49b4-9363-bdc90b17df6a",
        flowPNM6Plus: "a8f1a8a0-5ba8-44d8-b128-d7b0b9c83e2b",
        flowJZM5Plus: "64350c6d-59fb-4859-a0eb-f58fae163bc8",
        flowJNM5Plus: "553abfca-c1d9-44e3-891d-4121d9320b46",
        flowPZM4Plus: "52e9d9d1-9dc1-412f-8c72-d693c5f2eb2a",
        flowPNM4Plus: "2fdff511-c947-4e79-bc5c-3e2159656c3f",
        flowJZM3Plus: "e01cd0ca-d732-4093-943b-476f9a5c580b",
        flowJNM3Plus: "2afba54e-5003-4928-919a-d45d47232b7b",
        flowPZM2Plus: "98f69df0-d1aa-4ab2-8679-c4ac951e3f39",
        flowPNM2Plus: "01c08d49-ee69-43ba-b2e0-373a346f6083",
        flowJZM1Plus: "b8d90239-4eda-47b2-99e4-f0b4d64dc128",
        flowJNM1Plus: "fae7fa62-1382-4595-babd-192793f044a2",

        //running
        runningDehumidifierLeft: "GUID",
        runningDehumidifierRight: "GUID",

        //malfunction
        malfunctionDehumidifierLeft: "GUID",
        malfunctionDehumidifierRight: "GUID",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxPZ0: "b7a7bc41-7c44-4eee-844f-f6c496c9aa4c",
        humidityAllowedMaxPN0: "dcd022fa-dbb7-4602-b25a-1d980d051b1d",
        humidityAllowedMaxJZ1: "89c5760e-68da-4514-934e-06fc76c4c3be",
        humidityAllowedMaxJN1: "a523e8bd-f25f-4191-a34c-9b082ff81add",
        humidityAllowedMaxPZ2: "2be89920-f580-490f-af72-dbb6ab4988e9",
        humidityAllowedMaxPN2: "12dfebcc-aa51-48a8-a1ee-eb48f847bd86",
        humidityAllowedMaxJZ3: "78851098-4295-4907-83d4-b3c600867c44",
        humidityAllowedMaxJN3: "7ab5a8c4-9727-4448-a78f-d2188da78dd8",
        humidityAllowedMaxPZ4: "439fc8f5-237f-4034-97d8-a6d725289741",
        humidityAllowedMaxPN4: "38b2a8dc-74a1-42a8-bacb-c04cdf16e423",
        humidityAllowedMaxPZM6: "28f7fdb4-1664-47e8-bfd6-a0d3f6c01a62",
        humidityAllowedMaxPNM6: "32b36598-2a0b-42d5-b512-976d4113dce1",
        humidityAllowedMaxJZM5: "13bf98b6-a30c-466c-a041-572c35c378ec",
        humidityAllowedMaxJNM5: "3d71805a-0eee-4aea-866e-fe2e06a2a11d",
        humidityAllowedMaxPZM4: "6250987d-5a8d-4a00-88a3-5179f03d7863",
        humidityAllowedMaxPNM4: "e1e6cd8b-dcf4-416a-9a7e-67464fb29070",
        humidityAllowedMaxJZM3: "31a24627-298a-461c-a5ec-f1d2cf5b9310",
        humidityAllowedMaxJNM3: "e0ce6270-4654-4b6c-91ee-b34d190fc9bd",
        humidityAllowedMaxPZM2: "9c95de82-34d9-47f4-94dd-7ec0ed05c90a",
        humidityAllowedMaxPNM2: "da07cff9-9154-4902-b9e0-4b1b3da8bfd0",
        humidityAllowedMaxJZM1: "22d94e3f-1e20-4a95-8812-b13785a9f3e3",
        humidityAllowedMaxJNM1: "1df49bd7-1b47-44e1-accb-ab1e99958742",
        humidityAllowedMaxPZM0: "eb0fcf4c-21d7-451b-8a84-5d09de9d56f3",
        humidityAllowedMaxPNM0: "4965117a-a463-48db-a704-954fea7560a2",
        humidityAllowedMaxPZ0Plus: "5098cd4b-1da7-4147-9ffd-e82ff40ed0fd",
        humidityAllowedMaxPN0Plus: "b4c469be-0dcb-441f-bdad-5fa2c006bb5c",
        humidityAllowedMaxJZ1Plus: "6e58181c-ea4c-4b3a-bedc-484734e5e919",
        humidityAllowedMaxJN1Plus: "c103d74e-0131-4ad3-851c-695445769b89",
        humidityAllowedMaxPZ2Plus: "7338831c-e07b-4597-82fd-05ca2e4f6e2c",
        humidityAllowedMaxPN2Plus: "79b6a168-bc5c-459f-9e8c-0f6f5f561a80",
        humidityAllowedMaxJZ3Plus: "582a14db-b6b3-4496-821d-3341f609ca96",
        humidityAllowedMaxJN3Plus: "a5de7a39-bf78-42ea-855e-578965545521",
        humidityAllowedMaxPZ4Plus: "871617ba-84d6-4142-9fdd-e005761bd7a6",
        humidityAllowedMaxPN4Plus: "addc0561-99b7-4224-8926-93833f92669c",
        humidityAllowedMaxPZM6Plus: "de725c06-ede4-4bdf-b87f-8c19f4538155",
        humidityAllowedMaxPNM6Plus: "dadb6cd4-dc67-405d-8ef3-ffcd6f436b9a",
        humidityAllowedMaxJZM5Plus: "b14e1cc4-d893-4399-804e-b08e2d786f24",
        humidityAllowedMaxJNM5Plus: "678f0843-0002-4822-ae0a-20c4521aac0d",
        humidityAllowedMaxPZM4Plus: "c82b5039-f14d-4335-907d-4725887de518",
        humidityAllowedMaxPNM4Plus: "051c0b0d-ecd9-45a4-89d9-9ed58d84a7e5",
        humidityAllowedMaxJZM3Plus: "d8814cd9-6260-401d-ae18-77a099913181",
        humidityAllowedMaxJNM3Plus: "cc40c1d9-ec87-4072-a902-8affa2a1aeb7",
        humidityAllowedMaxPZM2Plus: "fb7ef1a2-5fba-48a1-a49f-75910b847470",
        humidityAllowedMaxPNM2Plus: "c8c39909-e06f-4aab-a4b5-b213c9571257",
        humidityAllowedMaxJZM1Plus: "000e9869-6bc7-4c2e-a592-d4ece922abce",
        humidityAllowedMaxJNM1Plus: "5c65d43e-e4f6-4292-890a-76c27b05ae77",
        humidityAllowedMaxDehumidifierLeft: "42e9d3e0-e6bb-4e99-a70a-84807a10db8b",
        humidityAllowedMaxDehumidifierRight: "7d31a969-65dd-4d8d-8466-6258bd6d97d5",
        humidityAllowedMaxDehumidifierEquivalentLeft: "3306957b-f730-4104-aacf-1377d9958a65",
        humidityAllowedMaxDehumidifierEquivalentRight: "ee5badbc-3e0c-4316-8074-2ebf3f619342",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityPZ0: "errorPZ0",
        humidityPN0: "errorPN0",
        humidityJZ1: "errorJZ1",
        humidityJN1: "errorJN1",
        humidityPZ2: "errorPZ2",
        humidityPN2: "errorPN2",
        humidityJZ3: "errorJZ3",
        humidityJN3: "errorJN3",
        humidityPZ4: "errorPZ4",
        humidityPN4: "errorPN4",
        humidityPZM6: "errorPZM6",
        humidityPNM6: "errorPNM6",
        humidityJZM5: "errorJZM5",
        humidityJNM5: "errorJNM5",
        humidityPZM4: "errorPZM4",
        humidityPNM4: "errorPNM4",
        humidityJZM3: "errorJZM3",
        humidityJNM3: "errorJNM3",
        humidityPZM2: "errorPZM2",
        humidityPNM2: "errorPNM2",
        humidityJZM1: "errorJZM1",
        humidityJNM1: "errorJNM1",
        humidityPZM0: "errorPZM0",
        humidityPNM0: "errorPNM0",
        humidityPZ0Plus: "errorPZ0Plus",
        humidityPN0Plus: "errorPN0Plus",
        humidityJZ1Plus: "errorJZ1Plus",
        humidityJN1Plus: "errorJN1Plus",
        humidityPZ2Plus: "errorPZ2Plus",
        humidityPN2Plus: "errorPN2Plus",
        humidityJZ3Plus: "errorJZ3Plus",
        humidityJN3Plus: "errorJN3Plus",
        humidityPZ4Plus: "errorPZ4Plus",
        humidityPN4Plus: "errorPN4Plus",
        humidityPZM6Plus: "errorPZM6Plus",
        humidityPNM6Plus: "errorPNM6Plus",
        humidityJZM5Plus: "errorJZM5Plus",
        humidityJNM5Plus: "errorJNM5Plus",
        humidityPZM4Plus: "errorPZM4Plus",
        humidityPNM4Plus: "errorPNM4Plus",
        humidityJZM3Plus: "errorJZM3Plus",
        humidityJNM3Plus: "errorJNM3Plus",
        humidityPZM2Plus: "errorPZM2Plus",
        humidityPNM2Plus: "errorPNM2Plus",
        humidityJZM1Plus: "errorJZM1Plus",
        humidityJNM1Plus: "errorJNM1Plus",

        temperaturerPZ0: "errorPZ0",
        temperaturerPN0: "errorPN0",
        temperaturerJZ1: "errorJZ1",
        temperaturerJN1: "errorJN1",
        temperaturerPZ2: "errorPZ2",
        temperaturerPN2: "errorPN2",
        temperaturerJZ3: "errorJZ3",
        temperaturerJN3: "errorJN3",
        temperaturerPZ4: "errorPZ4",
        temperaturerPN4: "errorPN4",
        temperaturerPZM6: "errorPZM6",
        temperaturerPNM6: "errorPNM6",
        temperaturerJZM5: "errorJZM5",
        temperaturerJNM5: "errorJNM5",
        temperaturerPZM4: "errorPZM4",
        temperaturerPNM4: "errorPNM4",
        temperaturerJZM3: "errorJZM3",
        temperaturerJNM3: "errorJNM3",
        temperaturerPZM2: "errorPZM2",
        temperaturerPNM2: "errorPNM2",
        temperaturerJZM1: "errorJZM1",
        temperaturerJNM1: "errorJNM1",
        temperaturerPZM0: "errorPZM0",
        temperaturerPNM0: "errorPNM0",
        temperaturerPZ0Plus: "errorPZ0Plus",
        temperaturerPN0Plus: "errorPN0Plus",
        temperaturerJZ1Plus: "errorJZ1Plus",
        temperaturerJN1Plus: "errorJN1Plus",
        temperaturerPZ2Plus: "errorPZ2Plus",
        temperaturerPN2Plus: "errorPN2Plus",
        temperaturerJZ3Plus: "errorJZ3Plus",
        temperaturerJN3Plus: "errorJN3Plus",
        temperaturerPZ4Plus: "errorPZ4Plus",
        temperaturerPN4Plus: "errorPN4Plus",
        temperaturerPZM6Plus: "errorPZM6Plus",
        temperaturerPNM6Plus: "errorPNM6Plus",
        temperaturerJZM5Plus: "errorJZM5Plus",
        temperaturerJNM5Plus: "errorJNM5Plus",
        temperaturerPZM4Plus: "errorPZM4Plus",
        temperaturerPNM4Plus: "errorPNM4Plus",
        temperaturerJZM3Plus: "errorJZM3Plus",
        temperaturerJNM3Plus: "errorJNM3Plus",
        temperaturerPZM2Plus: "errorPZM2Plus",
        temperaturerPNM2Plus: "errorPNM2Plus",
        temperaturerJZM1Plus: "errorJZM1Plus",
        temperaturerJNM1Plus: "errorJNM1Plus",

        pressurePZ0: "errorPZ0",
        pressurePN0: "errorPN0",
        pressureJZ1: "errorJZ1",
        pressureJN1: "errorJN1",
        pressurePZ2: "errorPZ2",
        pressurePN2: "errorPN2",
        pressureJZ3: "errorJZ3",
        pressureJN3: "errorJN3",
        pressurePZ4: "errorPZ4",
        pressurePN4: "errorPN4",
        pressurePZM6: "errorPZM6",
        pressurePNM6: "errorPNM6",
        pressureJZM5: "errorJZM5",
        pressureJNM5: "errorJNM5",
        pressurePZM4: "errorPZM4",
        pressurePNM4: "errorPNM4",
        pressureJZM3: "errorJZM3",
        pressureJNM3: "errorJNM3",
        pressurePZM2: "errorPZM2",
        pressurePNM2: "errorPNM2",
        pressureJZM1: "errorJZM1",
        pressureJNM1: "errorJNM1",
        pressurePZM0: "errorPZM0",
        pressurePNM0: "errorPNM0",
        pressurePZ0Plus: "errorPZ0Plus",
        pressurePN0Plus: "errorPN0Plus",
        pressureJZ1Plus: "errorJZ1Plus",
        pressureJN1Plus: "errorJN1Plus",
        pressurePZ2Plus: "errorPZ2Plus",
        pressurePN2Plus: "errorPN2Plus",
        pressureJZ3Plus: "errorJZ3Plus",
        pressureJN3Plus: "errorJN3Plus",
        pressurePZ4Plus: "errorPZ4Plus",
        pressurePN4Plus: "errorPN4Plus",
        pressurePZM6Plus: "errorPZM6Plus",
        pressurePNM6Plus: "errorPNM6Plus",
        pressureJZM5Plus: "errorJZM5Plus",
        pressureJNM5Plus: "errorJNM5Plus",
        pressurePZM4Plus: "errorPZM4Plus",
        pressurePNM4Plus: "errorPNM4Plus",
        pressureJZM3Plus: "errorJZM3Plus",
        pressureJNM3Plus: "errorJNM3Plus",
        pressurePZM2Plus: "errorPZM2Plus",
        pressurePNM2Plus: "errorPNM2Plus",
        pressureJZM1Plus: "errorJZM1Plus",
        pressureJNM1Plus: "errorJNM1Plus",

        flowPZ0: "errorPZ0",
        flowPN0: "errorPN0",
        flowJZ1: "errorJZ1",
        flowJN1: "errorJN1",
        flowPZ2: "errorPZ2",
        flowPN2: "errorPN2",
        flowJZ3: "errorJZ3",
        flowJN3: "errorJN3",
        flowPZ4: "errorPZ4",
        flowPN4: "errorPN4",
        flowPZM6: "errorPZM6",
        flowPNM6: "errorPNM6",
        flowJZM5: "errorJZM5",
        flowJNM5: "errorJNM5",
        flowPZM4: "errorPZM4",
        flowPNM4: "errorPNM4",
        flowJZM3: "errorJZM3",
        flowJNM3: "errorJNM3",
        flowPZM2: "errorPZM2",
        flowPNM2: "errorPNM2",
        flowJZM1: "errorJZM1",
        flowJNM1: "errorJNM1",
        flowPZM0: "errorPZM0",
        flowPNM0: "errorPNM0",
        flowPZ0Plus: "errorPZ0Plus",
        flowPN0Plus: "errorPN0Plus",
        flowJZ1Plus: "errorJZ1Plus",
        flowJN1Plus: "errorJN1Plus",
        flowPZ2Plus: "errorPZ2Plus",
        flowPN2Plus: "errorPN2Plus",
        flowJZ3Plus: "errorJZ3Plus",
        flowJN3Plus: "errorJN3Plus",
        flowPZ4Plus: "errorPZ4Plus",
        flowPN4Plus: "errorPN4Plus",
        flowPZM6Plus: "errorPZM6Plus",
        flowPNM6Plus: "errorPNM6Plus",
        flowJZM5Plus: "errorJZM5Plus",
        flowJNM5Plus: "errorJNM5Plus",
        flowPZM4Plus: "errorPZM4Plus",
        flowPNM4Plus: "errorPNM4Plus",
        flowJZM3Plus: "errorJZM3Plus",
        flowJNM3Plus: "errorJNM3Plus",
        flowPZM2Plus: "errorPZM2Plus",
        flowPNM2Plus: "errorPNM2Plus",
        flowJZM1Plus: "errorJZM1Plus",
        flowJNM1Plus: "errorJNM1Plus",

        humidityDehumidifierLeft: "errorDehumidifierLeft",
        temperatureDehumidifierLeft: "errorDehumidifierLeft",
        humidityDehumidifierRight: "errorDehumidifierRight",
        temperatureDehumidifierRight: "errorDehumidifierRight",
        humidityDehumidifierEquivalentLeft: "errorDehumidifierLeft",
        humidityDehumidifierEquivalentRight: "errorDehumidifierRight",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierLeft: "errorDehumidifierLeft",
        malfunctionDehumidifierRight: "errorDehumidifierRight",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityPZ0: "humidityTooltipErrorPZ0",
        humidityPN0: "humidityTooltipErrorPN0",
        humidityJZ1: "humidityTooltipErrorJZ1",
        humidityJN1: "humidityTooltipErrorJN1",
        humidityPZ2: "humidityTooltipErrorPZ2",
        humidityPN2: "humidityTooltipErrorPN2",
        humidityJZ3: "humidityTooltipErrorJZ3",
        humidityJN3: "humidityTooltipErrorJN3",
        humidityPZ4: "humidityTooltipErrorPZ4",
        humidityPN4: "humidityTooltipErrorPN4",
        humidityPZM6: "humidityTooltipErrorPZM6",
        humidityPNM6: "humidityTooltipErrorPNM6",
        humidityJZM5: "humidityTooltipErrorJZM5",
        humidityJNM5: "humidityTooltipErrorJNM5",
        humidityPZM4: "humidityTooltipErrorPZM4",
        humidityPNM4: "humidityTooltipErrorPNM4",
        humidityJZM3: "humidityTooltipErrorJZM3",
        humidityJNM3: "humidityTooltipErrorJNM3",
        humidityPZM2: "humidityTooltipErrorPZM2",
        humidityPNM2: "humidityTooltipErrorPNM2",
        humidityJZM1: "humidityTooltipErrorJZM1",
        humidityJNM1: "humidityTooltipErrorJNM1",
        humidityPZM0: "humidityTooltipErrorPZM0",
        humidityPNM0: "humidityTooltipErrorPNM0",
        humidityPZ0Plus: "humidityTooltipErrorPZ0Plus",
        humidityPN0Plus: "humidityTooltipErrorPN0Plus",
        humidityJZ1Plus: "humidityTooltipErrorJZ1Plus",
        humidityJN1Plus: "humidityTooltipErrorJN1Plus",
        humidityPZ2Plus: "humidityTooltipErrorPZ2Plus",
        humidityPN2Plus: "humidityTooltipErrorPN2Plus",
        humidityJZ3Plus: "humidityTooltipErrorJZ3Plus",
        humidityJN3Plus: "humidityTooltipErrorJN3Plus",
        humidityPZ4Plus: "humidityTooltipErrorPZ4Plus",
        humidityPN4Plus: "humidityTooltipErrorPN4Plus",
        humidityPZM6Plus: "humidityTooltipErrorPZM6Plus",
        humidityPNM6Plus: "humidityTooltipErrorPNM6Plus",
        humidityJZM5Plus: "humidityTooltipErrorJZM5Plus",
        humidityJNM5Plus: "humidityTooltipErrorJNM5Plus",
        humidityPZM4Plus: "humidityTooltipErrorPZM4Plus",
        humidityPNM4Plus: "humidityTooltipErrorPNM4Plus",
        humidityJZM3Plus: "humidityTooltipErrorJZM3Plus",
        humidityJNM3Plus: "humidityTooltipErrorJNM3Plus",
        humidityPZM2Plus: "humidityTooltipErrorPZM2Plus",
        humidityPNM2Plus: "humidityTooltipErrorPNM2Plus",
        humidityJZM1Plus: "humidityTooltipErrorJZM1Plus",
        humidityJNM1Plus: "humidityTooltipErrorJNM1Plus",
        humidityDehumidifierLeft: "humidityTooltipErrorDehumidifierLeft",
        humidityDehumidifierRight: "humidityTooltipErrorDehumidifierRight",
        humidityDehumidifierEquivalentLeft: "humidityTooltipErrorDehumidifierEquivalentLeft",
        humidityDehumidifierEquivalentRight: "humidityTooltipErrorDehumidifierEquivalentRight",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierLeft: "runningClassLeft",
        runningDehumidifierRight: "runningClassRight",
      },

      //station id list
      stationIdList: [
        "923f7894-bd81-4bc7-aace-137362d1dfcc",
        "9898ec82-1984-4f9f-b4ef-f8e1019c5176",
        "236a0656-c054-4af8-9610-d654fd72630a",
        "f5dac257-4b54-4292-9cf7-36e733aa8f65",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    hrefToScenario(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    },
    hrefToStation(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + id);
    },
  },
};
</script>
    
    <style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        font-weight: bold;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/xihoumen/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 94%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sensor-right-1 {
          top: 184px;
          left: 1132px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-3 {
          top: 153px;
          left: 1050px;
          &::before {
            bottom: -40px;
            left: -34px;
            width: 100px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -89px;
            left: 24px;
          }
          .state-info {
            right: -165px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-5 {
          top: 117px;
          left: 962px;
          &::before {
            bottom: 35px;
            left: -17px;
            width: 60px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 64px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-13 {
          top: 117px;
          left: 937px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-11 {
          top: 150px;
          left: 835px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-9 {
          top: 170px;
          left: 732px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-7 {
          top: 180px;
          left: 625px;
          &::before {
            bottom: -5px;
            left: -4px;
            width: 25px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -61px;
            top: 59px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-5 {
          top: 170px;
          left: 518px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-3 {
          top: 150px;
          left: 405px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-1 {
          top: 117px;
          left: 300px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-5 {
          top: 117px;
          left: 275px;
          &::before {
            bottom: 35px;
            left: -28px;
            width: 60px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 64px;
            left: -18px;
          }
          .state-info {
            right: 35px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-3 {
          top: 157px;
          left: 175px;
          &::before {
            bottom: -40px;
            left: -51px;
            width: 100px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -89px;
            left: -24px;
          }
          .state-info {
            right: 40px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-1 {
          top: 182px;
          left: 72px;
          &::before {
            bottom: 22px;
            left: -23px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -27px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-2 {
          top: 168px;
          left: 1093px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-4 {
          top: 132px;
          left: 998px;
          &::before {
            bottom: 38px;
            left: -21px;
            width: 70px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 73px;
            left: 20px;
          }
          .state-info {
            right: -165px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-12 {
          top: 135px;
          left: 885px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-10 {
          top: 158px;
          left: 805px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-8 {
          top: 177px;
          left: 675px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-6 {
          top: 177px;
          left: 570px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-4 {
          top: 158px;
          left: 440px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-2 {
          top: 135px;
          left: 350px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-4 {
          top: 132px;
          left: 240px;
          &::before {
            bottom: 38px;
            left: -33px;
            width: 70px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 73px;
            left: -19px;
          }
          .state-info {
            right: 34px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-2 {
          top: 168px;
          left: 145px;
          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -25px;
          }
          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .station-block-left {
          top: 108px;
          left: 282px;
        }

        .sta-left {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -73px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .station-block-right {
          top: 108px;
          left: 945px;
        }

        .sta-right {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -72px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 115px;
          }
        }
      }
    }
  }
}
</style>